import { useCurrentFrame, useVideoConfig, interpolate } from 'remotion';
import IdeShell from '../components/ide-shell';
import CodeEditorVideo from '../components/code-editor-video';
import OutputPanel from '../components/output-panel';

export default function FileSwitchScene({
  fromFile = 'Program.cs',
  toFile = 'Helper.cs',
  fromCode = '',
  toCode = '',
  projectName = 'HelloWorld',
}) {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();

  // Switch happens at 40% through the scene (mouse click moment)
  const switchFrame = Math.floor(fps * 0.8);
  const switched = frame >= switchFrame;
  const activeFile = switched ? toFile : fromFile;
  const displayCode = switched ? toCode : fromCode;
  const lineCount = displayCode ? displayCode.split('\n').length : 1;

  // Both tabs visible, active one highlighted
  const tabs = [
    { name: fromFile, active: !switched },
    { name: toFile, active: switched },
  ];

  return (
    <IdeShell projectName={projectName} filename={activeFile} step={2} lineCount={lineCount}>
      <CodeEditorVideo
        typedCode={displayCode}
        step={2}
        lineCount={lineCount}
        projectName={projectName}
        filename={activeFile}
        tabs={tabs}
      />
      <OutputPanel buildLogs={[]} />
    </IdeShell>
  );
}
